
















import { defineComponent, reactive } from '@vue/composition-api';
import { useFormat } from 'vivat';

import useDownloadReport from '@/useDownloadReport';

const NOW = useFormat.date().computerShortDate();

const PackageIncomeReport = defineComponent({
  setup() {
    const { getCSVReport } = useDownloadReport();
    const filter = reactive({
      range: {
        from: undefined,
        to: undefined,
      },
    });

    return {
      filter,
      getCSVReport,
    };
  },
});

export default PackageIncomeReport;
